import { useEffect, useState } from 'react';
import { onWriteError } from '../data/writes';

/** Write failures arrive out-of-band so the form never has to await them. */
export function Toast() {
  const [messages, setMessages] = useState<string[]>([]);

  useEffect(
    () =>
      onWriteError((err) => {
        setMessages((prev) => [...prev, err.message]);
        window.setTimeout(
          () => setMessages((prev) => prev.slice(1)),
          6000,
        );
      }),
    [],
  );

  if (messages.length === 0) return null;

  return (
    <div className="toasts" role="status" aria-live="polite">
      {messages.map((m, i) => (
        <p key={i} className="toast">
          Upload failed: {m}
        </p>
      ))}
    </div>
  );
}
